/**
 * The values represent the user's progress through the DMA onboarding wizard.
 */
export const DMA_ONBOARDING_STEPS = {
  SIGN_IN_COMPLETED: 1,
  COMPANY_COMPLETED: 2,
  FULLY_COMPLETED: 3,
} as const;

export type DmaOnboardingStep = (typeof DMA_ONBOARDING_STEPS)[keyof typeof DMA_ONBOARDING_STEPS];

const dmaFreemiumBasePath = '/dashboard';
const dmaOnboardingBasePath = `${dmaFreemiumBasePath}/sign-up`;

export const DMA_ONBOARDING_PATHS = {
  SIGN_UP: `${dmaOnboardingBasePath}`,
  LOGIN: `${dmaOnboardingBasePath}/login`,
  VERIFY_EMAIL: `${dmaOnboardingBasePath}/verify-email`,
  VALIDATE_LOGGED_IN_USER: `${dmaOnboardingBasePath}/validate-logged-in-user`,
  JOIN_ORGANISATION: `${dmaOnboardingBasePath}/join-organisation`,
  SELECT_COMPANY: `${dmaOnboardingBasePath}/setup-company/select-company`,
  ENTER_COMPANY: `${dmaOnboardingBasePath}/setup-company/enter-company`,
  SELECT_PRODUCTS: `${dmaOnboardingBasePath}/setup-company/select-products`,
  DASHBOARD: dmaFreemiumBasePath,
};
